import { ScoreCategory } from 'src/enums/score.categories';
import { ScoreNames } from 'src/enums/score.names';
import { IUpdateable } from 'src/pods/system/interfaces';
import { updater } from 'src/utils/ObjectUpdater';
import { getScoreNameByScoreCategory } from 'src/utils/helpers';

export default class SwabComponentModel implements IUpdateable<SwabComponentModel> {
    public averageScore!: number;
    public createdAt!: string;
    public description!: string;
    public genes!: string;
    public id!: number;
    public letsGetTechnical!: string;
    public maxValue!: number;
    public mean!: number;
    public median!: number;
    public minValue!: number;
    public numberOfSnps!: number;
    public percentile!: number;
    public percentile25th!: number;
    public percentile75th!: number;
    public recommendation!: string;
    public references!: string;
    public score!: number;
    public scoreCategory!: ScoreCategory;
    public scoreDescription!: string;
    public scoreMood!: true;
    public signs!: string;
    public title!: string;
    public componentID!: number;
    public updatedAt!: string;
    public riskLevel!: string;

    constructor(args?: Partial<SwabComponentModel>) {
        Object.assign(this, args);
    }

    public update(obj: Partial<SwabComponentModel>): SwabComponentModel {
        return updater.update(this, obj);
    }

    public isAverage() {
        return getScoreNameByScoreCategory(this.scoreCategory) === ScoreNames.AVERAGE;
    }

    public isDecreased() {
        return getScoreNameByScoreCategory(this.scoreCategory) === ScoreNames.DECREASED;
    }

    public isIncreased() {
        return getScoreNameByScoreCategory(this.scoreCategory) === ScoreNames.INCREASED;
    }
}
